/* Oasis FAQ accordions
   - Smooth height open/close animation on native <details>
   - One open at a time, scoped per section
   - Scroll fade-in entrance
   - Theme-editor aware (re-binds on section load, opens selected blocks)
   - Honors prefers-reduced-motion
   Safe to load anywhere; no-ops when there are no .oasis-faq-item elements. */
(function () {
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function answerOf(item) { return item.querySelector('.oasis-faq-answer'); }

  function openItem(item) {
    var ans = answerOf(item);
    if (!ans) return;

    // Close any open sibling in the same section first.
    var group = item.closest('.oasis-faq-section') || document;
    group.querySelectorAll('.oasis-faq-item[open]').forEach(function (other) {
      if (other !== item) closeItem(other);
    });

    item.open = true;

    if (REDUCE) { ans.style.height = ''; return; }

    item.classList.add('oasis-animating');
    var target = ans.scrollHeight;
    ans.style.height = '0px';
    ans.getBoundingClientRect(); // force reflow so the transition runs
    ans.style.height = target + 'px';

    ans.addEventListener('transitionend', function done(e) {
      if (e.propertyName !== 'height') return;
      ans.style.height = '';
      item.classList.remove('oasis-animating');
      ans.removeEventListener('transitionend', done);
    });
  }

  function closeItem(item) {
    var ans = answerOf(item);
    if (!ans) return;

    if (REDUCE) { item.open = false; ans.style.height = ''; return; }

    item.classList.add('oasis-animating');
    ans.style.height = ans.scrollHeight + 'px';
    ans.getBoundingClientRect(); // force reflow
    ans.style.height = '0px';

    ans.addEventListener('transitionend', function done(e) {
      if (e.propertyName !== 'height') return;
      item.open = false;
      ans.style.height = '';
      item.classList.remove('oasis-animating');
      ans.removeEventListener('transitionend', done);
    });
  }

  function onSummaryClick(e) {
    var item = e.currentTarget.parentNode;
    e.preventDefault();
    if (item.classList.contains('oasis-animating')) return;
    if (item.open) closeItem(item); else openItem(item);
  }

  function bind(root) {
    (root || document).querySelectorAll('.oasis-faq-item').forEach(function (item) {
      if (item.dataset.oasisFaqBound) return;
      item.dataset.oasisFaqBound = '1';
      var summary = item.querySelector('.oasis-faq-question');
      if (summary) summary.addEventListener('click', onSummaryClick);
    });
  }

  function fade(root) {
    var els = (root || document).querySelectorAll('.oasis-fade-in:not(.oasis-visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('oasis-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('oasis-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function run(root) { bind(root); fade(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(document); });
  } else {
    run(document);
  }

  // --- Theme editor support ---
  document.addEventListener('shopify:section:load', function (e) { run(e.target || document); });
  document.addEventListener('shopify:block:select', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('oasis-faq-item')) openItem(e.target);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('oasis-faq-item')) closeItem(e.target);
  });
})();
